import Tabs from './Tabs';

export default Tabs;
export { Tab } from '@mui/material';
export * from './Tabs.theme';
